import { KngCountOfItemCardDataState } from './definitions';

export class KngCountOfItemCardFactory 
{
	public static buildState(): KngCountOfItemCardDataState 
	{
		return {
			cssClass: '',
			cardType: 'unitCard',
			title: {
				label: ''
			},
			image: {
				label: '',
				url: '',
				alt: ''
			},
			unit: [
				{
					label: '',
					description: {
						label: ''
					},
					amount: ''
				}
			]
		};
	}
}
